export const details = {
    address: '1777 Lake Woodmoor Drive, Monument, CO 80132',
    phone: '(719) 488-3014',
};
